
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PositionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Position"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"assignOnly"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"qty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breakHrs"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unpaid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"breakQty"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"startTimeIso8601"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"endTimeIso8601"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minWageAvailable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ratingRequired"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"attireDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"details"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inhouseOptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"inHouseUniform"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agencyUniform"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dynamicStaffWage"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"positionList"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"filledShifts"},"name":{"kind":"Name","value":"listShifts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filled"},"value":{"kind":"BooleanValue","value":true}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"items"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"paid"},"arguments":[],"directives":[]}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"department"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"tags"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"color"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"attireTypes"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"image"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"listingCategory"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"certifications"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"orderDetail"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUpLocation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"poNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contactNumber"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"orderNotes"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":693}};
    doc.loc.source = {"body":"fragment PositionItem on Position {\n  id\n  name\n  assignOnly\n  qty\n  breakHrs\n  unpaid\n  breakQty\n  startTimeIso8601\n  endTimeIso8601\n  wage\n  minWageAvailable\n  ratingRequired\n  attireDescription\n  details\n  inhouseOptions {\n    inHouseUniform\n    agencyUniform\n    dynamicStaffWage\n  }\n  positionList {\n    id\n  }\n  filledShifts: listShifts(filled: true) {\n    totalCount\n    items {\n      id\n      paid\n    }\n  }\n  department {\n    id\n  }\n  tags {\n    id\n    name\n    category\n    color\n  }\n  attireTypes {\n    name\n    id\n    image\n    listingCategory\n  }\n  certifications {\n    id\n  }\n  orderDetail {\n    signUpLocation\n    poNumber\n    contactName\n    contactNumber\n    orderNotes\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["PositionItem"] = oneQuery(doc, "PositionItem");
        
